import { type ReactNode } from 'react';

import {
  type AriaLabelingProps,
  type DataTestId,
  type DOMProps,
  type StylingProps,
} from '@dynatrace/strato-components/core';

// #region Typings
/**
 * @public
 */
export interface TabProps
  extends StylingProps,
    DataTestId,
    AriaLabelingProps,
    DOMProps {
  /** Rendered contents of the option. */
  children: ReactNode;
  /**
   * Whether the tab should be disabled.
   * If true, the tab cannot be clicked and its tab panel does not render any content.
   * @defaultValue false
   */
  disabled?: boolean;
  /** The text shown on the tab. This must be unique. */
  title: string;
  /** The prefix icon shown in front of the tab text. */
  prefixIcon?: ReactNode;
  /**
   * Defines if the tabs content will be kept in the DOM, even if the content
   * is not shown to the user.
   * @defaultValue false
   */
  keepMounted?: boolean;
}
// #endregion

/**
 * Component used for specifying the Tab's title and content.
 * @public
 */
export const Tab = (props: TabProps) => null;
